define.alias("shared/decorators/track-call-duration", "settings/decorators/track-call-duration");